var exports = {
  "n": "xa15a2ab7--d870fb--link",
  "f": "xa15a2ab7--d870fb--without-pointer",
};

module.exports = exports;
